module.exports = __webpack_public_path__ + "static/media/pkr.static.8e158349.svg";